export default function Fix(){
  function eraselocalstorage(){
    window.localStorage.removeItem("jobs");
  }
  return(
    <button onClick={eraselocalstorage}>Klicke hier um all deine Probleme zu lösen</button>
  );
}